module.exports = __webpack_public_path__ + "media/images/photo08-aaa86033d6099dbac5652980c324b85b.png";